export const canBrowserShare = !!navigator.share

export const browserShare = ({ title, text, url }) =>
  navigator.share?.({ title, text, url })
